export class InvoiceClientPremium {
    id: string;
    premium: number;
    enteredDate: Date;
    changedDate: Date;
}
